module.exports = __webpack_public_path__ + "static/media/location.8d217ba5.png";